// eslint-disable-next-line no-shadow
enum EventExpenseType {
  TICKET,
  PRODUCT,
  GENERAL,
}

export default EventExpenseType;
